import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import AppRouter from '@/router/AppRouter';
import { useNavigationStore } from '@/stores/navigation.store';
import { useEffect } from 'react';

export default function App() {
  const setSPA = useNavigationStore(s => s.setSPA)

  useEffect(() => {
    setSPA()
  }, [setSPA])

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
